// extracted by mini-css-extract-plugin
export default {"ctn":"DebugOutputStrings_ctn_y9cac","table":"DebugOutputStrings_table_duoML"};